<template>

	<div>

		<section 
			:class="{'outer-pad': true }"
		>

			<form class="form normal full"><div :class="{ 'form-inputs-section': true, panel: true, google: isGoogleSignin }">

					<div>

					<h3 class="form-section-header">Personal details</h3>

					<p v-if="isGoogleSignin">You can only update your company name as the rest of your details are managed by Google.</p>

					<FormInput type="text" v-model="info.firstName" placeholder="Your first name" label="Your first name" :disabled="isGoogleSignin" class="form-input" :noMarginBottom="isGoogleSignin" />

					<FormInput type="text" v-model="info.lastName" placeholder="Your last name" label="Your last name" :disabled="isGoogleSignin" class="form-input" :noMarginBottom="isGoogleSignin" />

					<FormInput type="email" v-model="info.email" placeholder="Your email" label="Your email" :disabled="isGoogleSignin" class="form-input" :noMarginBottom="isGoogleSignin" />

					<FormInput type="text" v-model="info.companyName" placeholder="Company name" label="Company name" class="form-input" :noMarginBottom="isGoogleSignin" />

					</div>

				</div><div class="form-inputs-section panel" v-if="!isGoogleSignin">

					<h3 class="form-section-header">Update your password</h3>

					<FormInput type="password" v-model="currentPassword" placeholder="Current password" label="Current password" />

					<FormInput type="password" v-model="newPassword1" placeholder="New password" label="New password" />

					<FormInput type="password" v-model="newPassword2" placeholder="Repeat new password" label="Repeat new password" />

					<span 
						class="large-button"
						@click="updatePassword()" 
					>Update password</span>

				</div><div class="form-inputs-section enable-2fa panel" v-if="userType==='admin'">

						<h3 class="form-section-header">Add 2 Factor Authentication (2FA) To Your Account</h3>

						<p v-if="twoFactorEnabled">2 Factor Authentication Is Enabled</p>

						<p v-if="!twoFactorEnabled&&twoFactorInfo.qr===null&&!twoFactorEnabled">Download the Google Authenticator app for <a href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=en&gl=US" target="_blank">Android</a> or <a href="https://apps.apple.com/us/app/google-authenticator/id388497605" target="_blank">IOS</a>.</p>

						<span 
							@click="enable2FA()" 
							class="large-button mini" 
							v-if="twoFactorInfo.qr===null&&!twoFactorEnabled"
						>Enable</span>

						<div class="qr" v-if="twoFactorInfo.qr!==null&&!twoFactorEnabled"><img :src="twoFactorInfo.qr"></div>

						<FormInput type="number" v-if="twoFactorInfo.qr!==null&&!twoFactorEnabled" v-model="twoFactorCode" placeholder="Add the 6 digit code here" label="Scan the QR code using your authenticator app, type in the 6 digit code and hit submit" />

						<span 
							@click="enable2FA(1)" 
							class="large-button mini" 
							v-if="twoFactorInfo.qr!==null&&!twoFactorEnabled"
						>Submit</span>

					</div><div class="form-inputs-section panel api">

					<h3 class="form-section-header">Admin Access</h3>

					<p>If you are having some kind of issue with your account we may want to login as you to see what you are seeing, we are not able to do this unless you allow us to by toggling admin access on below, this is automatically turned off when we have logged in as you once or after 24 hours if we don't.</p>

					<Switcher 
			          switcherLabel="Blocked" 
			          switcherLabel2="Allowed" 
			          :sameColour="true" 
			          v-model="adminAccess"
			        />

				</div><div class="form-inputs-section panel api">

					<h3 class="form-section-header">API Access</h3>

					<p v-if="!showAPIaccess">If you would like API access to the platform please get in touch with us.</p>

					<FormInput type="text" v-model="api.key" v-if="showAPIaccess&&api.key&&api.key!==''" label="Your API Key" />

					<FormInput type="text" v-model="api.secret" label="Your API Secret (copy this and keep it safe, it won't be available once you've refreshed the page)" v-if="showAPIaccess&&api.secret&&api.secret!==''" />

					<span 
						class="large-button"
						@click="generateApiCreds()" 
						v-html="api.key!==''?'Re-Generate Creds':'Generate Creds'"
						v-if="showAPIaccess"
					/>

					<a href="/docs-api/" target="_blank" class="api-docs" v-if="showAPIaccess">API Docs</a>

					<a href="https://app.swaggerhub.com/apis-docs/Hovr/RankCaddy/1.0.0-oas3" target="_blank" class="api-docs" v-if="showAPIaccess">Swagger</a>

					<a href="/docs-api/openapi.json" target="_blank" class="api-docs" v-if="showAPIaccess">Open API JSON</a>

					<p v-html="apiDescription" class="api-info" v-if="showAPIaccess" />

				</div>

			</form>

			<div class="update-actions">

				<span 
					class="large-button"
					@click="submitData()" 
				>Update Profile</span>

			</div>

		</section>

	</div>

</template>

<script>
import Vue from 'vue';
import { mapMutations } from 'vuex'
import ApiService from './../../services/api.service'
import FormInput from './../../components/Form/Input.vue'
import Switcher from './../../components/Switcher.vue'
export default {
	name: 'AccountHome',
	components: {
		FormInput,
		Switcher
	},
	data() {
		return {
			info: {
				firstName: '',
				lastName: '',
				email: '',
				companyName: '',
				twoFactorEnabled: false,
				rcAdmin: false
			},
			api: {
				key: '',
				secret: ''
			},
			currentPassword: '',
			newPassword1: '',
			newPassword2: '',
			adminAccess: false,
			twoFactorCode: '',
			twoFactorEnabled: false,
			isGoogleSignin: false,
			twoFactorInfo: {
				qr: null
			}
		}
	},
	watch: {

		adminAccess (v) {

			ApiService.post( 'users', { adminAccess: v } )
			.then( function( info ) {

				

			}.bind(this))
			.catch( function(err) {
				console.log(err);
			});

		}

	},
	computed: {

		userType() {

			return !!this.info.rcAdmin ? 'admin' : 'user';

		},

		showAPIaccess () {

			return !!this.apiAllowed || this.userType === 'admin';

		},

		apiDescription () {

			let apiKey = ( typeof this.api !== 'undefined' && typeof this.api.key !== 'undefined' && this.api.key !== '' ) ? this.api.key : 'your-api-key';
			let apiSecret = ( typeof this.api !== 'undefined' && typeof this.api.secret !== 'undefined' && this.api.secret !== '' ) ? this.api.secret : 'your-api-secret';

			return 'The key & secret need to be added to the api url as query params like so... <br><br>' + window.location.origin + '/api/projects/?key=' + apiKey + '&secret=' + apiSecret;

		},
		apiKey () {
			
			return ( typeof this.api !== 'undefined' && !!this.api.key ) ? this.api.key : null;

		},
		apiSecret () {
			
			return ( typeof this.api !== 'undefined' && !!this.api.secret ) ? this.api.secret : null;

		},
		apiAllowed () {
			
			return ( !!this.apiKey && !!this.apiSecret ) || ( typeof this.api !== 'undefined' && !!this.api.allowed );

		}

	},
	methods: {

		...mapMutations('general',['updateLoadingText']),

		enable2FA(stage2) {

			if ( typeof stage2 !== 'undefined' ) {

				if ( this.twoFactorCode.length === 6 ) {

					this.updateLoadingText('One moment..');

					ApiService.post( 'users/2fa-confirm', { code: this.twoFactorCode, secret: this.twoFactorInfo.secret } )
			        .then( function( info ) {

			        	this.updateLoadingText();
			        	this.twoFactorEnabled = true;

			        }.bind(this) )
			        .catch( function(err) {
			            this.$snotify.error(err.response.data.error, '2FA Code');
			            this.updateLoadingText();
			        }.bind(this));

			    }
			    else {

			    	this.$snotify.error('The code should be 6 numbers!', '2FA Code');

			    }

			}
			else {

				ApiService.get( 'users/2fa-generate' )
		        .then( function( info ) {

		        	this.twoFactorInfo = info.data;
		        	this.updateLoadingText();

		        }.bind(this) )
		        .catch( function(err) {
		            console.log(err);
		        });

		    }

		},

		updatePassword () {

			if ( this.currentPassword !== '' && this.newPassword1 !== '' && this.newPassword2 !== '' ) {

				if ( this.newPassword1 !== this.newPassword2 ) {

					this.$snotify.error('Your new passwords do not match', 'Update Password');
					return;

				}

			}
			else {

				this.$snotify.error('Please enter all password fields', 'Update Password');
				return;
				
			}

            this.updateLoadingText('One moment...');

            ApiService.post( 'users/update-password', { currentPassword: this.currentPassword, newPassword1: this.newPassword1, newPassword2: this.newPassword2 } )
            .then( function( data ) {

                this.updateLoadingText();

                this.$snotify.success( data.data, 'Update Password' );

            }.bind(this))
            .catch( function(err) {

                this.updateLoadingText();
                
                this.$snotify.error( err.response.data.error, 'Update Password' );

            }.bind(this));

        },

		submitData () {

			var ok = true;

			if ( this.currentPassword !== '' || this.newPassword1 !== '' || this.newPassword2 !== '' ) {

				if ( this.currentPassword !== '' && this.newPassword1 !== '' && this.newPassword2 !== '' ) {



				}
				else {

					ok = false;
					this.$snotify.error('Please enter all password fields', 'Update Password');
					
				}

			}

			if ( ok ) {

				ApiService.post( 'users', this.info )
				.then( function( info ) {

					this.$snotify.success( info.data, 'Update Profile');

				}.bind(this))
				.catch( function(err) {
					this.$snotify.error( err.response.data.error, 'Update Profile' );
				}.bind(this));

			}

		},

		generateApiCreds() {

			if ( this.api && this.api.key ) {

				this.$dialog
					.confirm( "If you do this your current credentials will stop working!", { okText: 'That\'s fine', cancelText: 'Cancel',})
					.then(function() {

						ApiService.get( 'users/api-creds' )
						.then( function( info ) {

							this.api = info.data;

						}.bind(this))
						.catch( function(err) {
							console.log(err);
						});

					}.bind(this))
					.catch(function() {
						
						this.updateLoadingText();

					});

			}
			else {

				ApiService.get( 'users/api-creds' )
				.then( function( info ) {

					this.api = info.data;

				}.bind(this))
				.catch( function(err) {
					console.log(err);
				});

			}		

		}
		
	},
	created() {

		ApiService.get( 'users', null, 'Home' )
		.then( function( info ) {

			Object.keys(info.data).forEach( function (n) {

				if ( typeof this.info[n] !== 'undefined' ) {

					Vue.set(this.info, n, info.data[n]);

				}

			}.bind(this));

			this.isGoogleSignin = !!info.data.isGoogleSignin;

			this.twoFactorEnabled = !!this.info.twoFactorEnabled;

			this.adminAccess = typeof info.data.adminAccess !== 'undefined' ? info.data.adminAccess : false;

			if ( info.data.api && info.data.api.key ) this.api.key = info.data.api.key;

		}.bind(this))
		.catch( function(err) {
			console.log(err);
		});

	}
}
</script>

<style lang="less">
.api {
	.large-button {
		margin-bottom: 20px;
	}
	.api-docs {
		margin-left: 20px;
	}
	.api-info {
		word-wrap: break-word;
	}
}
.enable-2fa {

	p {

		margin: 0;

		a {
			text-decoration: underline !important;
		}

	}

	.qr {
		margin-bottom: 30px;
		min-width: 100px;
		min-height: 30px;
		position: relative;
		&:before {

			content:"Loading QR Code...";
			position: absolute;
			left: 0;
			top: 0;
			width: 150px;
			height: 30px;
			font-size: 16px;

		}
		img {
			display: block;
			z-index: 2;
			position: relative;
			width: 100%;
    		max-width: 250px;
		}
	}

}
@media screen and (min-width: 1024px) {
	.form-inputs-section {
		&.google {

			>div {

				display: flex;
				flex-wrap: wrap;
				gap: 20px;
				
				.form-input {
					flex: 0 0 calc(50% - 10px);
				}
				
				// Keep the header full width
				.form-section-header, > p {
					flex: 0 0 100%;
					margin: 0;
				}

				p {
					margin: 0;
				}

			}
		}
	}
}
</style>
